import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5","key":"svg-0"}],["path",{"d":"M12.5 21h-4.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 15.943 -.958","key":"svg-1"}],["path",{"d":"M16 19h6","key":"svg-2"}]]

const IconMoneybagMinus = createReactComponent('outline', 'moneybag-minus', 'MoneybagMinus', __iconNode);

export default IconMoneybagMinus;